import Vue from 'vue';

import $ from 'jquery';

import ProjectGalleries from "@/components/project-galleries/project-galleries.vue";



if($('.gallery-component-vue').length>0){
    $('.gallery-component-vue').each(function(index){
        let galleryId = $(this).data('galleryid')
        let useThumbnails = $(this).data('usethumbnails')
        new Vue({
            render(h) {
                return h(ProjectGalleries, { props: {galleryId: galleryId,galleryNumber:index,useThumbnails:useThumbnails} });
            },
            methods: {}
        }).$mount(this);
    });
}





